import React from 'react';

const MediaDropHint = () => (
  <div className='paxsudos-media-drop-hint'>
  </div>
);

export default MediaDropHint;
